import { ClientType } from '@/shared/constants/client/ClientType'
import { ReasonsForAbsence } from '@/shared/constants/booking/ReasonsForAbsence'
import dayjs from '@/services/date/index'

// Abstract Product
const BaseBookingInitialiser = () => {
  return {
    maxBookingsAllowed: 500,
    minBookingsPerDate: 1,
    maxBookingsPerDate: 100,
    minDate: dayjs().format('YYYY-MM-DD'),
    minDurationMinutes: 180,
    earliestEndTime: '10:00',
    reasons: ReasonsForAbsence,
  }
}

// Factory
export function BookingInitialiserFactory(clientTypeInt) {
  switch (clientTypeInt) {
    case ClientType.OSHC:
      return OshcBookingInitialiser()
    default:
      return BaseBookingInitialiser()
  }
}

// Concrete Products
const OshcBookingInitialiser = () => {
  const base = BaseBookingInitialiser()
  base.earliestEndTime = '09:00'
  base.minDurationMinutes = 120
  return base
}
